import React, { useState, useEffect, useContext } from "react";
import { AuthService } from "../../api/AuthService";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { RBCardView } from "../../components/RBCardView";
import { Spacing, Colors, FontSize } from "../../theme/Theme";
import {
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  RadioProps,
  withStyles,
  Select,
  MenuItem,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import { ApprovalModeEnum, Claims, EmptyString, roleNameEnum } from "../../util/Common";
import { showOnHoldAlert } from "../../util/showOnHoldAlert";
import SearchIcon from "@material-ui/icons/Search";
import { RBButton } from "../../components/RBButton";
import { ColumnStyle } from "../../theme/ComponentTheme";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import { useLocation, useHistory } from "react-router";
import { RoutePathConstant } from "../../util/Common";
import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import { RBContext } from "../../components/RBContext";
import { RBSelect } from "../../components/RBTextField";
import { DefaultIndustryModeEnum, IndustryModeEnum } from "../../api/constants";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { RBAlert } from "../../components/RBAlert";
import { AccountInfoContext } from "../../components/AccountInfoContext";

const GreenRadio = withStyles({
  root: {
    color: Colors.darkGrey,
    "&$checked": {
      color: Colors.black,
    },
  },
  checked: {},
})((props: RadioProps) => <Radio color="default" {...props} />);

export const SwitchPharmacy = () => {
  const [availableTypes, setAvailableTypes] = useState<any[]>([]);
  const [selectedPharmacyId, setSelectedPharmacyId] = useState(EmptyString);
  const [accountInfo, setAccountInfo] = useState<ObjectLiteral>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [registerType, setRegisterType] = useState(null);
  const [isAlertShowing, setIsAlertShowing] = useState(false);
  const [alertInfo, setAlertInfo] = useState<any>({ title: "", message: "", buttons: [] })
  const [searchTerm, setSearchTerm] = useState(EmptyString);
  const history = useHistory();
  const location = useLocation();
  const { industryMode, primaryColor, secondaryColor, updateMode, contactEmail } = useContext(RBContext);
  const [onHoldAlertState, setOnHoldAlertState] = useState<any>({ isAlertShowing: false, alertInfo: null });
  const isOwnerAccountOnHold = accountInfo?.owner?.approval?.approvalMode === ApprovalModeEnum.OnHold;
  const [workerAndLocations, setWorkerAndLocations] = useState<any>(null)
  const { accountInformation, fetchAccountInfo } = useContext(AccountInfoContext);


  const onAccountChanged = (data: string) => {
    console.log("onAccountChanged", data);
    setRefresh((pre) => !pre);
  };



  useEffect(() => {
    const unsub = NotificationService.subscribe(
      NotificationServiceTopic.AccountChanged,
      onAccountChanged
    );

    // Call Data to be refetched. Will then trigger Effect of Account
    const fetchData = async () => {

      if (refresh) {
        const userData = await fetchAccountInfo();
        setAccountInfo(userData);
      }

      if (!accountInfo) return;
    };

    fetchData();
    return () => {
      console.log("SwitchPharmacy clean up");
      unsub.unsubscribe();
    };
  }, [refresh]);

  // Update on Account Information
  // based on the new value of Account Info
  useEffect(() => {

    // Auto Call Code
    (async () => {
        
      if (!accountInfo) return; //early exit

      console.log('userData switch location ', accountInfo)
      const pharmacyId = accountInfo.owner.defaultPharmacyId || accountInfo.pharmacies[0].id;
      setSelectedPharmacyId(pharmacyId);
      console.log('selectedPharmacyId', pharmacyId);

      const [locationInfo, workerAndLocations] = await Promise.all([
        AuthService.getLocation(pharmacyId),
        AuthService.getRegisterEntities(),
      ]);

      const pharmacyLocation = locationInfo.data.companyType;
      const filteredData = workerAndLocations.data.filter(
        (value: any) => pharmacyLocation === value.locationType
      );

      updateMode(filteredData[0]?.industryMode);
      localStorage.setItem("industryMode", filteredData[0]?.industryMode)
      setWorkerAndLocations(workerAndLocations);

      const allNetwork = await AuthService.getAllNetworks(accountInfo.networks[0].industryType);
      setAvailableTypes(allNetwork.data);
      if (accountInfo.networks[0].industryModeDefault !== DefaultIndustryModeEnum.Custom) {
        setAvailableTypes(allNetwork.data.filter((item: any) => item.industryMode === accountInfo.networks[0].industryModeDefault));
      }
      // const getAllLocationTypes = await AuthService.getAllLocationTypes();
      //   const allLocationTypes = getAllLocationTypes.filter((item:any) => (item?.locationType === "Dental Practice" || item?.locationType === "Pharmacy"))
      //   setAvailableTypes(allLocationTypes);
      //   console.log("AVAILABLE TYPES", allLocationTypes)

    })();

  }, [accountInfo]);

  // Initial Population, update initial account info on first load
  useEffect(() => {
    if (accountInformation) {
      setAccountInfo(accountInformation);
    }
  }, [accountInformation]);

  const onSave = async () => {
    try {
    
      setIsSubmitting(true);
      await AuthService.updateOwner({
        defaultPharmacyId: selectedPharmacyId,
      });
      const locationInfo = await AuthService.getLocation(selectedPharmacyId);
      if (AuthService.getRoleName() !== roleNameEnum.regionalmanager) {
        localStorage.setItem("pharmacyName", locationInfo.data.name);
      }
      const userData = await fetchAccountInfo(); // ... i guess?
      setAccountInfo(userData)
      
      console.log('accountInfo switch ', userData);
      let pharmacyLocation = locationInfo.data.companyType;
      let filteredData = workerAndLocations.data.filter((value: any) => pharmacyLocation === value.locationType);
      updateMode(filteredData[0].industryMode);
      localStorage.setItem("industryMode", filteredData[0]?.industryMode)
      if (locationInfo.data.paymentType === null && accountInfo?.networks[0].paymentConfig.paymentEnabled) {
        setIsAlertShowing(true);
        setAlertInfo({
          title: "Payment Info Required",
          message: `Would you like to set up your payment information now?`,
          buttons: [

            <RBButton
              key={"confirm"}
              onClick={async () => {
                setIsAlertShowing(false);
                //setAlertShowing(false);
                history.push('/paymentOption', {
                  tabType: 'Shift',
                  editMode: false,
                  newPharmacy: true
                });
              }}
              buttonBackgroundColor={primaryColor}
              color="primary"
              text="Yes"
            />,
            <RBButton
              key={"confirm"}
              onClick={async () => {
                setIsAlertShowing(false);
                //setAlertShowing(false);
                history.push('/dashboard');
              }}
              buttonBackgroundColor={primaryColor}
              color="primary"
              text="No"
            />,
          ],
        });



        return;
      }
      else {
        history.push(RoutePathConstant.DashBoard)
      }
    } catch (error) {
      console.log("switch pharmacy save  error ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderPharmacies = () => {
    // const secondaryColorFromNetwork = accountInfo?.networks[0].brand.secondaryColor;
    // console.log('secondaryColorFromNetwork ', seconda);
    let title = industryMode === IndustryModeEnum.Pharmaceutical ? 'pharmacy' : industryMode === IndustryModeEnum.Dentistry ? 'dental practice' : 'company';
    let newTitle = industryMode === IndustryModeEnum.Pharmaceutical ? '*Pharmacy' : industryMode === IndustryModeEnum.Dentistry ? '*Dental Practice' : '*Company';
    const filteredPharmacies =
      accountInfo?.pharmacies?.filter((pharmacy: any) =>
        pharmacy.name?.toLowerCase().includes(searchTerm.trim().toLowerCase())
      ) || [];
    return (
      <RBCardView
        //s   marginHorizontal={Spacing.large}
        style={{
          margin: Spacing.large,
          padding: Spacing.large,
          height: "100%",
        }}
      >
        <Typography
          variant={"h6"}
          style={{ textAlign: "center", marginBottom: Spacing.larger }}
        >
          Select a {title} to edit its information or post a shift
        </Typography>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: `1px solid ${Colors.mediumGrey}`,
            borderRadius: 999,
            background: Colors.white,
            padding: "6px 12px",
            marginBottom: Spacing.medium,
          }}
        >
          <SearchIcon
            style={{
              color: primaryColor,
              fontSize: 18,
              marginRight: 8,
            }}
          />
          <InputBase
            fullWidth
            placeholder={`Search ${title} name`}
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            style={{ fontSize: 13 }}
          />
        </div>
        <FormControl
          component="fieldset"
          style={{ display: "flex", flex: 1, padding: Spacing.large }}
        >
          <RadioGroup
            value={selectedPharmacyId}
            onChange={(e) => setSelectedPharmacyId(e.target.value)}
          >
            {filteredPharmacies.map((pharmacy: any) => (
              <div
                key={pharmacy.id}
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  value={pharmacy.id}
                  control={<GreenRadio />}
                  label={pharmacy.name}
                />
                {pharmacy.approval.status !== "approved" && (
                  <div
                    style={{
                      fontSize: FontSize.small,
                      fontWeight: "lighter",
                      color: "red",
                    }}
                  >
                    Under Review
                  </div>
                )}
              </div>
            ))}
            {filteredPharmacies.length === 0 && (
              <Typography
                style={{
                  color: Colors.darkGrey,
                  fontSize: FontSize.small,
                  paddingTop: Spacing.small,
                }}
              >
                No matching {title} found.
              </Typography>
            )}
          </RadioGroup>
        </FormControl>
        <Typography variant={"caption"} style={{ padding: Spacing.large }}>
          {newTitle + ' ' + Claims.switchPharmacy}
        </Typography>


        <div
          style={{
            ...ColumnStyle,
            padding: Spacing.large,
            marginTop: Spacing.xlarge,
            marginLeft: "20%",
            marginRight: "20%",
          }}
        >
          <Select
            disableUnderline
            displayEmpty
            renderValue={registerType !== null ? undefined : () => "Register New Location"}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left"
              },
              getContentAnchorEl: null
            }}
            value={registerType}
            style={{
              width: "40%",
              background: secondaryColor,
              textAlign: 'center',
              color: 'white',
              borderRadius: 9,
              fontSize: 14,
              height: 40,
            }}
            onChange={(event) => {
              if (isOwnerAccountOnHold) {
                showOnHoldAlert({
                  setAlertState: setOnHoldAlertState,
                  primaryColor,
                  contactEmail,
                });
                return;
              }

              let filteredData = availableTypes.filter((val) => event.target.value === val.industryMode);
              history.push(RoutePathConstant.RegisterNewPharmacy, {
                ownerType: event.target.value,
                companyType: filteredData[0].displayName
              })
            }}
          >
            {availableTypes.map((value) => (
              <MenuItem value={value.industryMode} key={value.industryMode}>
                {value.displayName}
              </MenuItem>
            ))}
          </Select>
          <RBEmptyBlock style={{ width: "20%" }} />
          <RBButton
            style={{ display: "flex", flex: 1 }}
            buttonBackgroundColor={secondaryColor}
            text="Save"
            isLoading={isSubmitting}
            onClick={onSave}
          />
        </div>
      </RBCardView>
    );
  };

  return <>
    <RBAlert
      show={onHoldAlertState.isAlertShowing}
      alertTitle={onHoldAlertState.alertInfo?.title ?? ""}
      alertMessage={onHoldAlertState.alertInfo?.message ?? ""}
      buttons={onHoldAlertState.alertInfo?.buttons ?? []}
    />
    <RBAlert
      show={isAlertShowing}
      alertTitle={alertInfo.title}
      alertMessage={alertInfo.message}
      buttons={alertInfo.buttons}
    />
    {renderPharmacies()}
  </>;
};
